import React, { useState } from 'react';
import Sidebar from '../navigation/Sidebar';
import MobileMenuToggle from '../navigation/MobileMenuToggle';
import OverLimitBanner from '../OverLimitBanner';

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <OverLimitBanner />

      <MobileMenuToggle
        isOpen={sidebarOpen}
        onClick={toggleSidebar}
      />

      <Sidebar
        isOpen={sidebarOpen}
        onClose={closeSidebar}
      />

      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
